import {
    ILowFareResult,
    IOneWayLowFareReader,
    IRoundTripLowFareReader,
    LowFareStatusEnum
} from "./low-fare-reader.interface";

export class VoidOneWayLowFareReader implements IOneWayLowFareReader {

    getLowFare(date: Date): ILowFareResult {
        return {
            status: LowFareStatusEnum.Disabled
        };
    }

    async getLowFareAsync(date: Date): Promise<ILowFareResult> {
        return this.getLowFare(date);
    }

    dispose(): void {}
}


export class VoidRoundTripLowFareReader implements IRoundTripLowFareReader {

    dispose(): void {}

    getDepartureLowFare(date: Date): ILowFareResult {
        return {
            status: LowFareStatusEnum.Disabled
        };
    }

    getReturnLowFare(date: Date): ILowFareResult {
        return {
            status: LowFareStatusEnum.Disabled
        };
    }

    async getDepartureLowFareAsync(date: Date): Promise<ILowFareResult> {
        return this.getDepartureLowFare(date);
    }
    async getReturnLowFareAsync(date: Date): Promise<ILowFareResult> {
        return this.getReturnLowFare(date);
    }

}
